<template>
  <!--begin::Wrapper-->
  <div class="w-lg-500px bg-white rounded shadow-sm p-5 p-lg-5 mx-auto">
    <!--begin::Form-->
    <Form
      class="form w-100"
      id="kt_login_signin_form"
      @submit="onSubmitLogin"
      :validation-schema="login"
    >
      <!--begin::Heading-->
      <div class="text-center mb-10">
        <!--begin::Title-->
        <h1 class="text-dark mb-3">เข้าสู่ระบบบริการดีพร้อม</h1>
        <!--end::Title-->

        <!--begin::Link-->
        <!-- <div class="text-gray-400 fw-bold fs-4">
          New Here?

          <a :href="registerUrl" class="link-primary fw-bolder">
            Create an Account
          </a>
        </div> -->
        <!--end::Link-->
      </div>
      <!--begin::Heading-->

      <!-- <div class="mb-10 bg-light-info p-8 rounded">
        <div class="text-info">
          Use account <strong>admin@demo.com</strong> and password
          <strong>demo</strong> to continue.
        </div>
      </div> -->

      <!--begin::Input group-->
      <div class="fv-row mb-10">
        <!--begin::Label-->
        <label class="form-label fs-6 fw-bolder text-dark required"
          >Username : เลขบัตรประชาชน 13 หลัก</label
        >
        <!--end::Label-->

        <!--begin::Input-->
        <Field
          class="form-control form-control-lg form-control-white"
          type="text"
          name="username"
          autocomplete="off"
          placeholder="username"
        />
        <!--end::Input-->
        <div class="fv-plugins-message-container">
          <div class="fv-help-block">
            <ErrorMessage name="username" />
          </div>
        </div>
      </div>
      <!--end::Input group-->

      <!--begin::Input group-->
      <div class="fv-row mb-10">
        <!--begin::Wrapper-->
        <div class="d-flex flex-stack mb-2">
          <!--begin::Label-->
          <label class="form-label fw-bolder text-dark fs-6 mb-0 required"
            >Password : รหัสผ่าน i.industry</label
          >
          <!--end::Label-->

          <!--begin::Link-->
          <!-- <router-link to="/password-reset" class="link-primary fs-6 fw-bolder">
            Forgot Password ?
          </router-link> -->
          <!--end::Link-->
        </div>
        <!--end::Wrapper-->

        <!--begin::Input-->
        <Field
          class="form-control form-control-lg form-control-white"
          type="password"
          name="password"
          autocomplete="off"
          placeholder="password"
        />
        <!--end::Input-->
        <div class="fv-plugins-message-container">
          <div class="fv-help-block">
            <ErrorMessage name="password" />
          </div>
        </div>
      </div>
      <!--end::Input group-->

      <!-- begin::capcha -->
      <div class="form-floating d-flex flex-center mb-5">
        <vue-recaptcha
          v-show="showRecaptcha"
          :sitekey="siteKey"
          size="normal"
          theme="light"
          hl="th"
          @verify="recaptchaVerified"
          @expire="recaptchaExpired"
          @fail="recaptchaFailed"
          ref="vueRecaptcha"
        >
        </vue-recaptcha>
      </div>

      <!-- end::capcha -->

      <!--begin::Actions-->
      <div class="text-center">
        <!--begin::Submit button-->
        <button
          type="submit"
          :disabled="btnLoginDisabled"
          ref="submitButton"
          id="kt_sign_in_submit"
          class="btn btn-lg btn-primary w-100 mb-5"
        >
          <span class="indicator-label"> เข้าสู่ระบบ </span>

          <span class="indicator-progress">
            Please wait...
            <span
              class="spinner-border spinner-border-sm align-middle ms-2"
            ></span>
          </span>
        </button>
        <!--end::Submit button-->
      </div>
      <!--end::Actions-->

      <!--begin::redirect i-industry-->
      <div class="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
        <div></div>

        <!--begin::Link-->
        <a
          class="cursor-pointer link-primary fs-6 fw-bolder"
          v-on:click="CheckBeforeSignUp"
          >สมัครเข้ารับบริการ (Sign Up)</a
        >
        <!--end::Link-->
      </div>
      <!--end::redirect i-industry-->

      <!--begin::forgot password-->
      <div class="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
        <div></div>

        <!--begin::Link-->
        <a
          class="cursor-pointer link-primary fs-6 fw-bolder"
          :href="iIndustryResetPasswordUrl"
          >ลืมรหัสผ่าน ?</a
        >
        <!--end::Link-->
      </div>
      <!--end::forgot password-->
    </Form>
    <!--end::Form-->
  </div>
  <!--end::Wrapper-->
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import vueRecaptcha from "vue3-recaptcha2";
import { CookieComponent } from "@/assets/ts/components/_CookieComponent";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "sign-in",
  components: {
    Field,
    Form,
    ErrorMessage,
    vueRecaptcha,
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    //ของ DRI
    const registerUrl = process.env.VUE_APP_DRI_LINK;
    //ของ i-industry reset password
    const iIndustryResetPasswordUrl =
      process.env.VUE_APP_IINDUSTRY_RESET_PASSWORD_LINK;

    const submitButton = ref<HTMLButtonElement | null>(null);

    //Create form validation object
    const login = Yup.object().shape({
      username: Yup.string()
        .min(1)
        .required("Username is required.")
        .label("Username"),
      password: Yup.string().min(4).required().label("Password"),
    });

    const CheckBeforeSignUp = () => {
      let url = "";
      Swal.fire({
        title:
          "คุณต้องการสมัครเป็นสมาชิกลูกค้ากระทรวงอุตสาหกรรม (i-Industry) หรือไม่",
        icon: "question",
        reverseButtons: true,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "สมัครสมาชิก",
        denyButtonText: "ไม่สมัครสมาชิก",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          url = "https://i.industry.go.th/register/";
          window.open(url, "_blank");
        }
      });
    };

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    //Form submit function
    const onSubmitLogin = async (values) => {
      if (!reCapchaChecked.value) return;

      // Clear existing errors
      store.dispatch(Actions.LOGOUT);

      if (submitButton.value) {
        // eslint-disable-next-line
        submitButton.value!.disabled = true;
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
      }
      // Send login request
      await store.dispatch(Actions.LOGIN, values);
      const [errorName] = Object.keys(store.getters.getErrors);
      const error = store.getters.getErrors[errorName];

      if (!error) {
        Swal.fire({
          text: "You have successfully logged in!",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Ok, got it!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        }).then(function () {
          // Go to page after successfully login
          router.push({
            path: "/JoinEvent/Dashboard/",
            query: { Ref: 12367 },
          });

          //เช็คว่าเคยกด consent ไปหรือยัง
          var userInfo = JSON.parse(CookieComponent.get("UserInfo") || "");
          if (!userInfo?.ConsentIsConfirm) {
            //modal consent
            swalWithBootstrapButtons
              .fire({
                title:
                  '<strong style="color:#009EF7">การยินยอมให้ใช้ข้อมูล</strong>',
                html:
                  '<small> <strong>"ผู้ใช้บริการ"</strong> ยินยอมให้ <strong>"ผู้ให้บริการ"</strong> นำข้อมูลไปวิเคราะห์' +
                  "<br> และประมวลผลรวมถึงการส่งข้อมูล เช่น รายละเอียดส่วนตัว ข้อมูลประกอบกิจการ ข้อมูลโรงงานและข้อมูลบริษัท" +
                  "<br>ที่อยู่ในระบบบริการดีพร้อม (DIPROM E-Services) ให้แก่ " +
                  "<br>ระบบอื่นๆที่อยู่ภายใต้การเชื่อมโยงของ " +
                  '<br><strong>"ระบบบริการดีพร้อม (DIPROM E-Services)"</strong>' +
                  "<br>เพื่อขอรับบริการจากระบบดังกล่าว</small>",
                iconHtml:
                  '<i class="bi bi-shield-fill-check  text-info" style="font-size: 8rem;"></i>',

                showCancelButton: true,
                confirmButtonText: "ยินยอม",
                cancelButtonText: "ไม่ยินยอม",
                reverseButtons: true,
                allowOutsideClick: false,
              })
              .then((result) => {
                if (result.isConfirmed) {
                  //ไปอัพเดท consent_date
                  ApiService.put("Member/UpdateConsentDate", {})
                    .then(({ data }) => {
                      if (data.Data) {
                        var response = data.Data;
                        console.log("UpdateConsentDate :", response);
                      }
                    })
                    .catch(({ response }) => {
                      console.log("error", response.data.Description);
                    });
                } else {
                  // Clear existing errors
                  store.dispatch(Actions.LOGOUT);

                  router.push({
                    path: "/sign-in",
                  });
                }
              });
          }
        });
      } else {
        Swal.fire({
          text: error[0],
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }

      //Deactivate indicator
      submitButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      submitButton.value!.disabled = false;
    };

    // reCapcha
    // const vueRecaptcha = ref<null | HTMLFormElement>(null);
    const btnLoginDisabled = ref(true);
    const reCapchaChecked = ref(false);
    const showRecaptcha = ref(true);

    const recaptchaVerified = (response) => {
      if (response) {
        reCapchaChecked.value = true;
        btnLoginDisabled.value = false;
      }
      //console.log("test recaptchaVerified", response);
    };

    const recaptchaExpired = () => {
      reCapchaChecked.value = false;
      btnLoginDisabled.value = true;
      //this.$refs.vueRecaptcha.reset();
      //console.log("test recaptchaExpired");
    };

    // ถ้า error จะเข้าตรงนี้อาจจะเอาไว้ใส่ modal ให้ติดต่อ admin
    const recaptchaFailed = () => {
      console.log("test recaptchaFailed");
    };
    const siteKey = "6LcqTikmAAAAAEM5Yq4gv4ZMWWBKrx_m4SclkUmT";

    onMounted(() => {
      if (window.location.origin == "http://localhost:8080") {
        showRecaptcha.value = false;
        btnLoginDisabled.value = false;
        reCapchaChecked.value = true;
      }
    });

    return {
      registerUrl,
      onSubmitLogin,
      login,
      submitButton,
      CheckBeforeSignUp,
      iIndustryResetPasswordUrl,
      recaptchaVerified,
      recaptchaExpired,
      recaptchaFailed,
      siteKey,
      reCapchaChecked,
      showRecaptcha,
      btnLoginDisabled,
    };
  },
});
</script>
